import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { CustomReportDebugChatThreadSchema } from "./custom-report-debug-schema";

export const getCustomReportDebugChatThreads = unaryRpc({
  name: "getCustomReportDebugChatThreads" as const,
  input: z.object({ id: z.string().trim().min(1) }),
  output: z.object({ chatThreads: z.array(CustomReportDebugChatThreadSchema) }),
});

export type GetCustomReportDebugChatThreadsOutput = z.infer<
  typeof getCustomReportDebugChatThreads.output
>;
